// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"eb361f42","795":"c280c7f5"}[chunkId] + ".chunk.js";
};